import React, { useState, useEffect } from 'react';
import CookieModal from './CookieModal';

const CookieBanner = ({ isDarkMode }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showCookieModal, setShowCookieModal] = useState(false);

  useEffect(() => {
    // Zkontroluj, jestli už uživatel cookies přijal
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    const cookiesRejected = localStorage.getItem('cookiesRejected');
    
    if (!cookiesAccepted && !cookiesRejected) {
      // Zobraz banner po krátkém zpoždění pro lepší UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    setIsVisible(false);
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('cookiePreferences', JSON.stringify({
      necessary: true,
      functional: true,
      analytics: true,
      marketing: true
    }));
    
    // Zde můžete spustit Analytics nebo jiné tracking skripty
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted'
      });
    }
  };

  const handleAcceptNecessary = () => {
    setIsVisible(false);
    localStorage.setItem('cookiesRejected', 'true');
    localStorage.setItem('cookiePreferences', JSON.stringify({
      necessary: true,
      functional: false,
      analytics: false,
      marketing: false
    }));
    
    // Zakáže Analytics a marketing cookies
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied'
      });
    }
  };

  const handleCustomize = () => {
    // Pro pokročilé nastavení - zde by mohlo být další modal s detailním nastavením
    setShowCookieModal(true);
  };

  if (!isVisible) {
    return (
      <>
        <CookieModal 
          isOpen={showCookieModal} 
          onClose={() => setShowCookieModal(false)} 
        />
      </>
    );
  }

  return (
    <>
      <div className={`fixed top-0 left-0 right-0 z-50 transform transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}>
        <div className={`${
          isDarkMode 
            ? 'bg-gray-900 border-gray-700' 
            : 'bg-white border-gray-200'
        } border-b shadow-2xl backdrop-blur-sm`}>
          <div className="container mx-auto px-4 sm:px-6 py-4 sm:py-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              
              {/* Text a ikona */}
              <div className="flex items-start gap-3 flex-1">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                    <span className="text-white text-sm">🍪</span>
                  </div>
                </div>
                
                <div className="flex-1">
                  <h4 className={`font-semibold mb-1 ${
                    isDarkMode ? 'text-white' : 'text-gray-900'
                  }`}>
                    Používáme cookies pro lepší zážitek
                  </h4>
                  <p className={`text-sm leading-relaxed ${
                    isDarkMode ? 'text-gray-300' : 'text-gray-600'
                  }`}>
                    Naše webové stránky používají cookies pro zajištění základní funkčnosti, 
                    analýzu návštěvnosti a zlepšení vašeho zážitku. Některé cookies jsou nezbytné, 
                    jiné používáme pouze s vaším souhlasem.{' '}
                    <button
                      onClick={() => setShowCookieModal(true)}
                      className={`underline hover:no-underline font-medium ${
                        isDarkMode 
                          ? 'text-blue-400 hover:text-blue-300' 
                          : 'text-blue-600 hover:text-blue-700'
                      }`}
                    >
                      Více informací o cookies
                    </button>
                  </p>
                </div>
              </div>
              
              {/* Tlačítka */}
              <div className="flex flex-col sm:flex-row gap-2 lg:gap-3 min-w-fit">
                <button
                  onClick={handleAcceptNecessary}
                  className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-300 ${
                    isDarkMode
                      ? 'text-gray-300 hover:text-white hover:bg-gray-700 border border-gray-600'
                      : 'text-gray-700 hover:text-gray-900 hover:bg-gray-100 border border-gray-300'
                  }`}
                >
                  Jen nezbytné
                </button>
                
                <button
                  onClick={handleAcceptAll}
                  className="px-6 py-2 text-sm font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                >
                  Přijmout vše
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <CookieModal 
        isOpen={showCookieModal} 
        onClose={() => setShowCookieModal(false)} 
      />
    </>
  );
};

export default CookieBanner;